import styled from "styled-components";

import { Button } from "/component/base";

export const CancelButton = styled(Button)({ alignSelf: "center" });
